import React, { useState, useEffect } from "react";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Breadcrumb,
  ProgressBar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Routes } from "../../routes.js";
import axios from "axios";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import BASE_URL from "../../config";



export default () => {
  const [selectedStatus, setSelectedStatus] = useState("0"); // State to store the selected status
  const [applications, setApplications] = useState([]); // State to store fetched applications
  const [loading, setLoading] = useState(false); // State to manage loading
  const [customMessage, setCustomMessage] = useState(""); // State to manage the custom message
  const [isLoading, setIsLoading] = useState(false);



   const [showPopup, setShowPopup] = useState(false);
    const [popupType, setPopupType] = useState(""); // "success" or "error"
    const [popupMessage, setPopupMessage] = useState("");
    const [countdown, setCountdown] = useState(3); // Countdown in seconds
    const [showDefaultUpdate, setShowDefaultUpdate] = useState(false);

  // Status map to render appropriate labels for status values
  const statusMap = {
    0: "Application Approved",
    1: "Application Declined",
    2: "Application Suspended",
    3: "Incomplete Application",
    4: "Waiting For Merchant",
    5: "Waiting For Bank",
    6: "Waiting For Agent",
    7: "Application Applied",
  };

  // Dynamic message templates for each status
  const messageTemplates = {
    0: "Congratulations! Your application has been approved.",
    1: "Unfortunately, your application has been declined.",
    2: "Your application has been suspended for further review.",
    3: "Your application is incomplete. Please provide the missing details.",
    4: "We are waiting for your response to proceed with your application.",
    5: "We are waiting for the bank to approve your application.",
    6: "We are waiting for the agent's response on your application.",
    7: "Your application has been successfully submitted and is under review.",
  };

  // Function to fetch applications based on the selected status
  const fetchApplicationsByStatus = async (status) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api.php?type=applicationsByStatus&status=${status}`
      );
      setApplications(response.data);
      generateCustomMessage(response.data, status); // Generate custom message based on applications
    } catch (error) {
      console.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };

  // Generate custom message for the current applications based on the selected status
  const generateCustomMessage = (applications, status) => {
    const messages = applications
      .map((app) => {
        return `Dear ${app.user_name}, ${messageTemplates[status]} (Application ID: ${app.id}). Regards, Blueberry Merchant.`;
      })
      .join("\n\n");
    setCustomMessage(messages); // Set the custom message in state
  };

  // Handle status change
  const handleStatusChange = (e) => {
    const status = e.target.value;
    setSelectedStatus(status);
    fetchApplicationsByStatus(status); // Fetch applications based on the selected status
  };

  // Handle sending the email to all users when "Update Status" is clicked
  // const handleUpdateStatus = async () => {
  //   try {
  //     const response = await axios.post('/api.php', {
  //       type: 'sendMail', // Backend action to send mail
  //       message: customMessage, // Send custom message
  //       applications: applications.map(app => ({
  //         email: app.user_email,
  //         name: app.user_name,
  //         app_id: app.id,
  //         status: selectedStatus
  //       }))
  //     });
  //     alert(response.data.message); // Success message
  //   } catch (error) {
  //     console.error("Error sending emails:", error);
  //     alert("An error occurred while sending emails.");
  //   }
  // };

  useEffect(() => {
      if (showPopup) {
        setCountdown(2); // Reset countdown
        const interval = setInterval(() => {
          setCountdown((prev) => prev - 1);
        }, 1000);
  
        const timer = setTimeout(() => {
          clearInterval(interval);
  
          // Wait 1 additional second after countdown finishes
          setTimeout(() => {
            setShowPopup(false);
          }, 1000);
        }, 3000);
  
        return () => {
          clearInterval(interval);
          clearTimeout(timer);
        };
      }
    }, [showPopup]);



  const handleUpdateStatus = async () => {
    setIsLoading(true);
    try {
      const applicationsWithMessages = applications.map((app) => ({
        email: app.user_email,
        name: app.user_name,
        app_id: app.id,
        status: selectedStatus,
        message: `Dear ${app.user_name},
                  ${messageTemplates[selectedStatus]} (Application ID: ${app.id}).
                  Regards, Blueberry Merchant.`,
      }));

      // Make the POST request and handle text response
      const response = await axios.post(
        `${BASE_URL}/api.php`,
        {
          type: "sendMail",
          applications: applicationsWithMessages,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setPopupType("success");
        setPopupMessage("Emails Sent Successfully!");
        setShowPopup(true);
      // Display the plain text message from response.data
      // alert(response.data); // Shows either "Emails sent successfully!" or "Some emails failed to send."
    } catch (error) {
        console.error("Error sending emails:", error);
    setPopupType("error");
    setPopupMessage("An error occurred while sending emails.");
    setShowPopup(true)
    }
    finally {
      setIsLoading(false); // Set loading to false once the process ends
    }
  };

  return (
    <>
      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(255, 255, 255, 0.9)",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            padding: "20px 30px",
            zIndex: 1050,
            textAlign: "center",
          }}
        >
          <FontAwesomeIcon
            icon={popupType === "success" ? faCheckCircle : faExclamationCircle}
            className={popupType === "success" ? "text-success" : "text-danger"}
            size="3x"
          />
          <h5 className="mt-3 fw-bold">{popupMessage}</h5>
          <div className="mt-3">
            <ProgressBar
              now={(countdown / 3) * 100}
              striped
              variant={popupType === "success" ? "success" : "danger"}
              style={{ transition: "width 1s linear" }}
            />
          </div>
        </div>
      )}
  
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <Link to={"/dashboard/overview"}>
                <FontAwesomeIcon icon={faHome} />
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Auto Reply</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Auto Reply</h4>
        </div>
      </div>
      <Card border="light" className="bg-white mb-4">
        <Card.Body>
          <Form>
            <Row>
              <Col md={9}>
                <Col md={12} className="mb-3">
                  <Form.Group id="type">
                    <Form.Label>Application Status</Form.Label>
                    <Form.Select
                      value={selectedStatus}
                      onChange={handleStatusChange}
                    >
                      <option value="0">Application Approved</option>
                      <option value="1">Application Declined</option>
                      <option value="2">Application Suspended</option>
                      <option value="3">Incomplete Application</option>
                      <option value="4">Waiting For Merchant</option>
                      <option value="5">Waiting For Bank</option>
                      <option value="6">Waiting For Agent</option>
                      <option value="7">Application Applied</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    {/* Display the dynamic message for all applications */}
                    <Form.Control
                      as="textarea"
                      rows="8"
                      value={customMessage}
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <hr />
                <div className="mt-3">
                  <Button
                    onClick={handleUpdateStatus}
                    variant="primary"
                    disabled={isLoading} // Disable button while loading
                    style={{
                      cursor: isLoading ? "not-allowed" : "pointer",
                      opacity: isLoading ? 0.7 : 1,
                    }}
                  >
                    {isLoading ? "Sending Emails..." : "Send Emails"} {/* Show loading text */}
                  </Button>
                </div>
              </Col>
              <Col md={3}>
                <h4>Legend</h4>
                <hr />
                {loading ? (
                  <p>Loading applications...</p>
                ) : applications.length > 0 ? (
                  applications.map((app) => (
                    <div key={app.id}>
                      <Form.Group id="Name">
                        <Form.Label>
                          Application Status: {statusMap[selectedStatus]}
                        </Form.Label>
                      </Form.Group>
                      <Form.Group id="Name">
                        <Form.Label>Customer Name: {app.user_name}</Form.Label>
                      </Form.Group>
                      <Form.Group id="Name">
                        <Form.Label>Customer Email: {app.user_email}</Form.Label>
                      </Form.Group>
                      <hr />
                    </div>
                  ))
                ) : (
                  <p>No applications found for the selected status.</p>
                )}
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
  
};
